import { ADD_GLOBAL_BILL_CODE, DELETE_GLOBAL_BILL_CODE, GET_GLOBAL_BILL_CODES, UPDATE_GLOBAL_BILL_CODE, UPDATE_GLOBAL_BILL_CODE_STATUS } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_GLOBAL_BILL_CODES:
            return {...state, list: payload};

        case UPDATE_GLOBAL_BILL_CODE:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };
        case UPDATE_GLOBAL_BILL_CODE_STATUS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_GLOBAL_BILL_CODE:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_GLOBAL_BILL_CODE:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
